import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FeatureList, PlanCardShell, PlanToggle, Price, Swap } from './PlanCardShell';

const PRO_POINTS = [
  'Unlimited teams & tournaments',
  'Every bracket format + printable brackets',
  'Standings, tie-breakers & season analytics',
  'Live stat tracking for 5 sports',
  'AI schedule import & box-score scanning',
  'Rosters, branded exports & multi-admin',
];

const AnnualPrice = ({ plan }) => (
  <>
    <Price amount={plan.price} unit="/year" testId="plan-price-pro_annual" />
    <p className="text-sm text-slate-500 mt-3">Just <b className="text-[#00247D]">${plan.monthly_equivalent} USD/mo</b> billed annually</p>
    <span className="inline-block mt-2 rounded-full bg-emerald-100 text-[#007A38] text-xs font-bold px-2.5 py-0.5" data-testid="pro-annual-savings">Save {plan.discount} vs monthly</span>
  </>
);

const MonthlyPrice = ({ plan }) => (
  <>
    <Price amount={plan.price} unit="/month" testId="plan-price-pro_monthly" />
    <p className="text-sm text-slate-500 mt-3">Billed monthly. No minimum commitment.</p>
  </>
);

const ProCta = ({ plan, isPro, currentPlan, onSelect }) => {
  const cls = 'w-full h-12 bg-[#00247D] hover:bg-[#001A5C] text-white font-bold transition-[background-color,transform] active:scale-[0.98]';
  if (isPro && currentPlan === 'pro_monthly' && plan.id === 'pro_annual') {
    return <Link to="/billing"><Button className={cls} data-testid="select-plan-pro_annual">Switch to Annual in Billing</Button></Link>;
  }
  return (
    <Button onClick={() => onSelect(plan.id)} disabled={isPro} data-testid={`select-plan-${plan.id}`} className={cls}>
      {isPro ? 'Current Plan' : <><CreditCard className="w-4 h-4 mr-2" />Get Pro</>}
    </Button>
  );
};

export const ProPlanCard = ({ monthly, annual, cycle, onCycle, isPro, currentPlan, onSelect, paypal }) => {
  const plan = cycle === 'annual' ? annual : monthly;
  return (
    <PlanCardShell tone="pro" badge="For organizers" title="Pro" testId="pricing-card-pro"
      subtitle="Everything you need to run tournaments and leagues."
      control={<PlanToggle value={cycle} onChange={onCycle} testId="billing-cycle"
        options={[['monthly', 'Monthly'], ['annual', `Annual · Save ${annual.discount}`]]} />}
      price={<Swap active={cycle} items={{ annual: <AnnualPrice plan={annual} />, monthly: <MonthlyPrice plan={monthly} /> }} />}
      features={<FeatureList items={PRO_POINTS} testId="pro-features" />}
      footer={paypal || <ProCta plan={plan} isPro={isPro} currentPlan={currentPlan} onSelect={onSelect} />} />
  );
};
